import 'intl-list-format';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { Settings } from 'luxon';

import { AppComponent } from './app/app.component';

registerLocaleData(localeDe, 'de-DE');
registerLocaleData(localeEn, 'en-US');
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

import { browserTracingIntegration, init as initSentry } from '@sentry/angular';
import posthog from 'posthog-js';
import { init as initDash0 } from '@dash0/sdk-web';
import { resolveApiUrl } from '@catch/libs';

if (environment.production) {
  enableProdMode();

  if (window) {
    window.console.log = () => {};
  }
}

if (environment.sentryEnabled) {
  initSentry({
    dsn: 'https://5ca9470d85e07b6a4cf1c2c89a7f76d1@o4509632216694784.ingest.de.sentry.io/4509632685867088',
    release: environment.release,
    environment: environment.environment,
    tracePropagationTargets: ['localhost', 'https://company.catch-talents.de'],
    integrations: [browserTracingIntegration()],
    tracesSampleRate: 1.0,
  });
}

if (environment.posthogEnabled) {
  posthog.init('phc_aG026KkCjfw0a39SJm2wCARMVjUe7FbVzqE3KBfFTD1', {
    api_host: 'https://eu.i.posthog.com',
    person_profiles: 'always',
  });
}

if(environment.dash0Enabled) {
  initDash0({
    serviceName: `${environment.environment}-company-tool`,
    endpoint: {
      url: 'https://ingress.eu-west-1.aws.dash0.com',
      authToken: 'auth_UoQhgAjPju0EHqAd4VGfno2P8YUfyu5R',
      dataset: environment.production ? 'production' : 'staging',
    },
    additionalSignalAttributes: {
      environment: environment.environment,
      version: environment.version,
    },
  });
}

Settings.defaultZone = 'Europe/Berlin';

const initializeApp = async () => {
  environment.apiBaseUrl = await resolveApiUrl(
    environment.apiBaseUrl,
    environment.apiBaseUrlFallback,
    { enabled: !environment.production }
  );

  bootstrapApplication(AppComponent, appConfig).catch((err) => {
    console.error('Bootstrap failed:', err);
  });
};

initializeApp();
